export default __webpack_public_path__ + "static/media/fortune.5f08a0de.png";